export default "__VITE_ASSET__BgKbh_w8__"